import React from 'react';
import { RecoilRoot } from 'recoil';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SidebarProvider } from './contexts/SidebarContext';
// changed by Cursor: import ThemeProvider for dark mode
import { ThemeProvider } from './contexts/ThemeContext';
import LogInPage from './pages/Leaner/LearnerLogIn';
import LearnerDashboard from './pages/Leaner/LearnerDashboard';
import LanguageLearningPage from './pages/Leaner/LanguageLearningPage';
import LearnerReport from './pages/Leaner/LearnerReport';
import LearnerProfile from './pages/Leaner/LearnerProfile';
import QuickPractice from './pages/Leaner/LanguageLearningPage/Practice/QuickPractice';
import WritingPractice from './pages/Leaner/LanguageLearningPage/Practice/WritingPractice';
import SpeakingPractice from './pages/Leaner/LanguageLearningPage/Practice/SpeakingPractice';
import ResultPage from './pages/Leaner/LanguageLearningPage/Practice/ResultPage';
import SkillResultPage from './pages/Leaner/LanguageLearningPage/Practice/SkillResultPage';
import ReviewPage from './pages/Leaner/LanguageLearningPage/Practice/ReviewPage';
import DrillVocab from './pages/Leaner/LanguageLearningPage/Practice/DrillVocab';
import VocabReviewPage from './pages/Leaner/LanguageLearningPage/Practice/VocabReviewPage';
// changed by Cursor: disable management routes
// import ManagementDashboard from './pages/Management/ManagementDashboard';
// import ManagementLogIn from './pages/Management/ManagementLogIn';
import LearnerProtectedRoute from './routes/LearnerProtectedRoute';
import ThirdPartySession from './pages/Leaner/ThirdPartySession';

function App() {
  return (
    <RecoilRoot>
      <ThemeProvider>
      <SidebarProvider>
        <HashRouter>
          <Routes>
            {/* Learner Routes */}
            <Route path="/learner/login" element={<LogInPage />} />
            <Route path="/learner/dashboard" element={<LearnerProtectedRoute><LearnerDashboard /></LearnerProtectedRoute>} />
            <Route path="/learner/language-learning" element={<LearnerProtectedRoute><LanguageLearningPage /></LearnerProtectedRoute>} />
            <Route path="/learner/english-language-learning" element={<LearnerProtectedRoute><LanguageLearningPage /></LearnerProtectedRoute>} />
            <Route path="/learner/japanese-language-learning" element={<LearnerProtectedRoute><LanguageLearningPage /></LearnerProtectedRoute>} />
            <Route path="/learner/report" element={<LearnerProtectedRoute><LearnerReport /></LearnerProtectedRoute>} />
            <Route path="/learner/profile" element={<LearnerProtectedRoute><LearnerProfile /></LearnerProtectedRoute>} />
            <Route path="/learner/settings" element={<Navigate to="/learner/profile" replace />} />
            <Route path="/quick-practice" element={<LearnerProtectedRoute><QuickPractice /></LearnerProtectedRoute>} />
            <Route path="/writing-practice" element={<LearnerProtectedRoute><WritingPractice /></LearnerProtectedRoute>} />
            <Route path="/speaking-practice" element={<LearnerProtectedRoute><SpeakingPractice /></LearnerProtectedRoute>} />
            <Route path="/learner/result" element={<LearnerProtectedRoute><ResultPage /></LearnerProtectedRoute>} />
            <Route path="/learner/skill-result" element={<LearnerProtectedRoute><SkillResultPage /></LearnerProtectedRoute>} />
            <Route path="/drill-vocab" element={<LearnerProtectedRoute><DrillVocab /></LearnerProtectedRoute>} />
            <Route path="/learner/review" element={<LearnerProtectedRoute><ReviewPage /></LearnerProtectedRoute>} />
            <Route path="/learner/vocab-review" element={<LearnerProtectedRoute><VocabReviewPage /></LearnerProtectedRoute>} />
            
            {/* Management Routes - disabled */}
            {/* <Route path="/management/login" element={<ManagementLogIn />} /> */}
            {/* <Route path="/management/dashboard" element={<ManagementDashboard />} /> */}

            {/* Third-Party Entry */}
            <Route path="/third-party" element={<ThirdPartySession />} />
            
            {/* Default Route */}
            <Route path="/" element={<Navigate to="/learner/login" replace />} />
            <Route path="*" element={<Navigate to="/learner/login" replace />} />
          </Routes>
        </HashRouter>
      </SidebarProvider>
      </ThemeProvider>
    </RecoilRoot>
  );
}

export default App;
